<script setup lang="ts">
const route = useRoute()
const isHomepage = computed(() => route.path === '/')
const { isAuthenticated } = useAuth()

const mobileMenuOpen = ref(false)

watch(() => route.path, () => {
  mobileMenuOpen.value = false
})
</script>

<template>
  <header class="sticky top-0 z-50 bg-primary border-b border-green-600">
    <div class="container mx-auto px-4 h-16 flex items-center gap-4">
      <NuxtLink to="/" class="flex items-center gap-2 shrink-0">
        <UIcon name="i-lucide-heart-pulse" class="size-8 text-white" />
        <span class="font-semibold text-lg hidden sm:inline text-white">Veterina Pohotovost</span>
      </NuxtLink>

      <div class="flex-1">
        <SearchBar v-if="!isHomepage" size="sm" class="max-w-xl" />
      </div>

      <!-- Desktop nav -->
      <UButton
        to="/pro-veterinare"
        color="neutral"
        variant="ghost"
        size="xl"
        class="hidden md:inline-flex text-white hover:bg-white/10"
      >
        Pro veterináře
      </UButton>

      <ClientOnly>
        <template v-if="isAuthenticated">
          <UButton
            to="/administrace"
            color="neutral"
            variant="solid"
            size="xl"
            class="hidden md:inline-flex !bg-white !text-primary hover:!bg-green-50 active:!bg-green-100 dark:!bg-white dark:!text-primary dark:hover:!bg-green-50"
          >
            Můj účet
          </UButton>
        </template>

        <template v-else>
          <UButton
            to="/prihlaseni"
            color="neutral"
            variant="solid"
            size="xl"
            class="hidden md:inline-flex !bg-white !text-primary hover:!bg-green-50 active:!bg-green-100 dark:!bg-white dark:!text-primary dark:hover:!bg-green-50"
          >
            Přihlásit se
          </UButton>
        </template>

        <template #fallback>
          <div class="hidden md:block w-[108px] h-9 rounded-md bg-white/20 animate-pulse" />
        </template>
      </ClientOnly>

      <UColorModeButton size="xl" class="hidden md:inline-flex text-white hover:bg-white/10" variant="link" />

      <!-- Mobile hamburger -->
      <UButton
        color="neutral"
        variant="ghost"
        icon="i-lucide-menu"
        class="md:hidden text-white hover:bg-white/10"
        @click="mobileMenuOpen = true"
      />

      <!-- Mobile menu -->
      <USlideover v-model:open="mobileMenuOpen" title="Menu">
        <template #body>
          <nav class="flex flex-col gap-1">
            <UButton
              to="/pro-veterinare"
              variant="ghost"
              color="neutral"
              size="xl"
              icon="i-lucide-stethoscope"
              block
              class="justify-start"
            >
              Pro veterináře
            </UButton>

            <UButton
              to="/blog"
              variant="ghost"
              color="neutral"
              size="xl"
              icon="i-lucide-newspaper"
              block
              class="justify-start"
            >
              Blog
            </UButton>

            <ClientOnly>
              <UButton
                v-if="isAuthenticated"
                to="/administrace"
                variant="ghost"
                color="neutral"
                size="xl"
                icon="i-lucide-user"
                block
                class="justify-start"
              >
                Můj účet
              </UButton>
              <UButton
                v-else
                to="/prihlaseni"
                variant="ghost"
                color="neutral"
                size="xl"
                icon="i-lucide-log-in"
                block
                class="justify-start"
              >
                Přihlásit se
              </UButton>
            </ClientOnly>

            <USeparator class="my-3" />

            <div class="flex items-center justify-between px-3">
              <span class="text-base text-muted">Tmavý režim</span>
              <UColorModeButton size="xl" />
            </div>
          </nav>
        </template>
      </USlideover>
    </div>
  </header>
</template>
